import {
  ComponentProps,
  ComponentType,
  forwardRef,
  PropsWithoutRef,
  Ref,
} from 'react';
import { ErrorBoundary, ErrorBoundaryProps } from './ErrorBoundary';

interface ExtendErrorContextDescription {
  componentName?: string;
  errorContextDescription?: string;
}

const extendErrorContextDescription = ({
  componentName,
  errorContextDescription,
}: ExtendErrorContextDescription) => {
  const prefix = componentName ? `Error in ${componentName}:` : '';
  return [prefix, errorContextDescription].join(' ');
};

export const withErrorBoundaries = (boundariesProps: ErrorBoundaryProps) =>
  function wrap<T>(WrappedComponent: ComponentType<PropsWithoutRef<T>>) {
    return forwardRef(
      (props: ComponentProps<typeof WrappedComponent>, ref: Ref<any>) => (
        <ErrorBoundary
          {...boundariesProps}
          errorContextDescription={extendErrorContextDescription({
            componentName: WrappedComponent.displayName,
            errorContextDescription: boundariesProps.errorContextDescription,
          })}
        >
          <WrappedComponent {...(props as PropsWithoutRef<T>)} ref={ref} />
        </ErrorBoundary>
      )
    );
  };
